import React from 'react';

/**
 * Catches React errors in child components so we never show a blank crash screen.
 * Renders a fallback with a link home (no Redirect, since ErrorBoundary wraps Router).
 */
class ErrorBoundary extends React.Component {
	constructor(props) {
		super(props);
		this.state = { hasError: false };
	}

	static getDerivedStateFromError() {
		return { hasError: true };
	}

	componentDidCatch(error, info) {
		console.error('ErrorBoundary caught:', error, info);
	}

	render() {
		if (this.state.hasError) {
			return (
				<div style={{ padding: '2rem', textAlign: 'center', fontFamily: 'sans-serif' }}>
					<p style={{ marginBottom: '1rem' }}>Something went wrong. Please try again.</p>
					<a href="/">Go to home</a>
				</div>
			);
		}
		return this.props.children;
	}
}

export default ErrorBoundary;
